import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1706.66667,0 L213.333333,0 C94.9333333,0 0,108 0,240 L0,1680 C0,1812 94.9333333,1920 213.333333,1920 L1706.66667,1920 C1824,1920 1920,1812 1920,1680 L1920,240 C1920,108 1824,0 1706.66667,0 Z M853.333333,853.333333 L693.333333,853.333333 L693.333333,800 L480,800 L480,1120 L693.333333,1120 L693.333333,1066.66667 L853.333333,1066.66667 L853.333333,1173.33333 C853.333333,1232 805.333333,1280 746.666667,1280 L426.666667,1280 C368,1280 320,1232 320,1173.33333 L320,746.666667 C320,688 368,640 426.666667,640 L746.666667,640 C805.333333,640 853.333333,688 853.333333,746.666667 L853.333333,853.333333 Z M1600.33333,853.333333 L1440.33333,853.333333 L1440.33333,800 L1227,800 L1227,1120 L1440.33333,1120 L1440.33333,1066.66667 L1600.33333,1066.66667 L1600.33333,1173.33333 C1600.33333,1232 1552.33333,1280 1493.66667,1280 L1173.66667,1280 C1115,1280 1067,1232 1067,1173.33333 L1067,746.666667 C1067,688 1115,640 1173.66667,640 L1493.66667,640 C1552.33333,640 1600.33333,688 1600.33333,746.666667 L1600.33333,853.333333 Z",
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: "1"
});

var IconClosedCaptioningSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconClosedCaptioningSolid, _Component);

  var _super = _createSuper(IconClosedCaptioningSolid);

  function IconClosedCaptioningSolid() {
    _classCallCheck(this, IconClosedCaptioningSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconClosedCaptioningSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconClosedCaptioning",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconClosedCaptioningSolid.displayName = "IconClosedCaptioningSolid";
  return IconClosedCaptioningSolid;
}(Component);

IconClosedCaptioningSolid.glyphName = 'closed-captioning';
IconClosedCaptioningSolid.variant = 'Solid';
IconClosedCaptioningSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconClosedCaptioningSolid;
export { IconClosedCaptioningSolid };